import React, { memo } from 'react'

import { SectionItem } from '../sectionItem'

import styles from './myDescription.module.scss'

function MyDescription() {
  return (
    <SectionItem topic="Profile">
      <div className={styles.description__text}>
        <>
          <div>
            I&apos;m a
             software developer
            who always like to
             learn new things.
          </div>
          <div>
            I&apos;m focusing on
             mobile and website technology.
          </div>
        </>
      </div>
    </SectionItem>
  )
}

export default memo(MyDescription)
